import React from 'react'
import { useSelector } from 'react-redux'
import { isPrivate } from 'data/channels/record'
import { providesChannelMutations } from 'components/Channels/dataSync'
import { Text } from 'components/base'
import ChannelRolesManagementInput from './ChannelRolesManagementInput'
import ChannelTypeSelector from '../../ChannelTypeSelector'

import { canManageChannel } from 'remote/channels/roles'
import { selectors as ChannelsSelectors } from 'data/channels'

export type ChannelPermissionsFormProps = {
  channelId: string
  updateChannel: (
    args: {
      id: string
      type: string
    }
  ) => void
}

export default providesChannelMutations(function ChannelPermissionsForm({
  channelId,
  updateChannel,
}: ChannelPermissionsFormProps) {
  const channel = useSelector(state =>
    ChannelsSelectors.getChannel(state, channelId)
  )
  const canManage = canManageChannel({ channel })

  const setChannelType = React.useCallback(
    (type: string) => {
      if (!channel) {
        return
      }
      updateChannel({
        id: channel.id,
        type,
      })
    },
    [channel, updateChannel]
  )

  return (
    <React.Fragment>
      <div className="flexbox flexbox-align-center margin-bottom-larger">
        <div className="flexbox-grow">
          <Text.Section className="margin-bottom-small">
            Make private
          </Text.Section>
          <Text.Corpus>
            Restrict which team members can access this channel.
          </Text.Corpus>
          <div />
        </div>
        <ChannelTypeSelector
          value={isPrivate(channel) ? 'private' : 'public'}
          onChange={setChannelType}
          disabled={!canManage}
          incentiveId="ManageChannelsPermissions"
        />
      </div>
      <Text.Section className="margin-bottom-normal">
        Channel members
      </Text.Section>
      <ChannelRolesManagementInput channelId={channel.id} />
    </React.Fragment>
  )
})
